import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { OnDemandPreloadOptions } from './on-demand-preload-options.class';

@Injectable({ providedIn: 'root' })
export class OnDemandPreloadService {
	state: Observable<OnDemandPreloadOptions>;
	private readonly subject = new Subject<OnDemandPreloadOptions>();

	constructor() {
		// Expose as public observable
		this.state = this.subject.asObservable();
	}
}
